import React from 'react';

import { Box } from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { BulkEditionMenu } from 'common/components';

const BulkOperationsCard = ({
    canDelete,
    filterData,
    handleClickBulkItems,
    prefix,
    selectedBulkOption,
    selectionModel,
    setSelectedBulkOption,
    setSelectionModel,
}) => {
    const { t } = useTranslation();
    const isArchivedList = filterData?.status === 'archived';
    const callback = () => {
        setSelectedBulkOption('');
        setSelectionModel([]);
    };

    if (isEmpty(selectionModel) || !canDelete) return null;
    return (
        <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
            <BulkEditionMenu
                items={[
                    {
                        handleClick: () =>
                            handleClickBulkItems(
                                selectionModel,
                                'archived',
                                filterData,
                                callback,
                            ),
                        label: t('Archive'),
                        visible: !isArchivedList,
                    },
                    {
                        handleClick: () =>
                            handleClickBulkItems(
                                selectionModel,
                                'active',
                                filterData,
                                callback,
                            ),
                        label: t('Unarchive'),
                        visible: isArchivedList,
                    },
                    {
                        handleClick: () =>
                            handleClickBulkItems(
                                selectionModel,
                                'deleted',
                                filterData,
                                callback,
                            ),
                        label: t('Delete'),
                        visible: isArchivedList,
                    },
                ]}
                prefix={prefix}
                selectedBulkOption={selectedBulkOption}
                setSelectionModel={setSelectionModel}
            />
        </Box>
    );
};

BulkOperationsCard.propTypes = {
    canDelete: PropTypes.bool,
    filterData: PropTypes.object,
    handleClickBulkItems: PropTypes.func,
    prefix: PropTypes.string,
    selectedBulkOption: PropTypes.string,
    selectionModel: PropTypes.array,
    setSelectedBulkOption: PropTypes.func,
    setSelectionModel: PropTypes.func,
};

export default BulkOperationsCard;
